var modules_3717c142 = {"container":"_i91ye","color-blue":"_qagut5","color-gray":"_xf1mjy","color-dark":"_1755osk","strong":"_1w3w6bc"};
import "../../../assets/Cu0r0w_i.css";

export { modules_3717c142 as default };
//# sourceMappingURL=Link.module.less.js.map
